import '@/Components/Environmental/Environmental.less';
import { useEventStream } from '@/Components/Hooks/useEventStream';
import useGetCurrentConditions from '@/Components/Hooks/useGetCurrentConditions';
import useGetUserAccessories from '@/Components/Hooks/useGetUserAccessories';
import { SSEEventContext } from '@/Components/SmartHome/SSEEventContext';
import { CONFIG_SUPPORTED_DEVICES_KB_URL_KEY, SENSOR_SSE_EVENTS } from '@/constants/device';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { getUserConfig } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SmartHomeIcon, SupportedDevicesIcon } from '../Common/Icons';
import { SensorsList } from './SensorsList';

const SmartHome = ({
  userInfo,
  timezone,
  loginUserTimeformat,
  openSubMenu,
  hubRecord,
  loginUserMeasurementUnit,
}) => {
  const trans = useSelector(translator);
  const userData = useSelector((user) => user.data.userInfo);
  const useruuid = hubRecord?.useruuid || '';
  const hubConfig = useSelector(getUserConfig(useruuid));
  const supportedDevicesKbUrl = useMemo(
    () => get(hubConfig, CONFIG_SUPPORTED_DEVICES_KB_URL_KEY, ''),
    [hubConfig]
  );

  // const [showEnvSupportModal, setShowEnvSupportModal] = useState(false);
  // const [envSupportDeviceData, setEnvSupportDeviceData] = useState([]);
  // const [activeSupportDevicesTab, setActiveSupportDevicesTab] = useState('');

  const getTempUnit = useCallback(() => {
    if (loginUserMeasurementUnit?.measurement) {
      return loginUserMeasurementUnit.measurement === 'metric' ? 'C' : 'F';
    }
    return null;
  }, [loginUserMeasurementUnit]);

  const { data: currentConditions } = useGetCurrentConditions({
    useruuid,
    postalcode: userInfo.postalcode,
    city: userInfo.city,
  });

  // const { data: allDeviceModels } = useGetDeviceModelsByTypes({
  //   deviceTypes: SMART_HOME_DEVICE_TYPES,
  // });

  // useEffect(() => {
  //   if (allDeviceModels?.length) {
  //     const firstDeviceType = Object.keys(allDeviceModels)[0];
  //     if (firstDeviceType) {
  //       setActiveSupportDevicesTab(firstDeviceType);
  //     }
  //   }
  // }, [allDeviceModels]);

  const { latestEvent: sseEvent } = useEventStream(userInfo, SENSOR_SSE_EVENTS);

  const currentUser = useSelector(getCurrentUser);

  const currentUseruuid = useMemo(() => currentUser?.useruuid, [currentUser]);

  const currentUserDataInfo = userData[openSubMenu ? useruuid : currentUseruuid];

  const { data: accessories = [], isLoading } = useGetUserAccessories(hubRecord);

  const handleSupportedDevicesClick = useCallback(() => {
    if (supportedDevicesKbUrl) {
      window.open(supportedDevicesKbUrl, '_blank', 'noopener,noreferrer');
    }
  }, [supportedDevicesKbUrl]);

  // const closeEnvSupportModal = () => {
  //   setShowEnvSupportModal(false);
  //   setEnvSupportDeviceData([]);
  // };

  // const handleSupportDeviceModal = (device_type) => {
  //   setActiveSupportDevicesTab(device_type);
  //   setEnvSupportDeviceData(allDeviceModels[device_type] || []);
  // };

  // const showEnvSupportDeviceModal = () => {
  //   const sortedKeys = Object.keys(allDeviceModels).sort((a, b) => a.localeCompare(b));
  //   const defaultTab = sortedKeys[0] || SENSORS.SMART_HOME.ENVIRONMENTAL_SENSOR;
  //   setActiveSupportDevicesTab(defaultTab);
  //   setEnvSupportDeviceData(allDeviceModels[defaultTab] || []);
  //   setShowEnvSupportModal(true);
  // };

  return (
    <SSEEventContext.Provider value={{ sseEvent }}>
      <div style={{ padding: '40px 40px 0px', paddingBottom: '80px' }}>
        <div className="header-container">
          <div className="header-icon-title">
            <SmartHomeIcon style={{ fill: '#113E57', width: '32px', height: '32px' }} />
            <div className="header-title">{trans('SMART_HOME')}</div>
          </div>
          <div
            className="supported-devices-container"
            onClick={handleSupportedDevicesClick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSupportedDevicesClick();
              }
            }}
            role="button"
            tabIndex={0}
            style={{ cursor: 'pointer' }}
          >
            <SupportedDevicesIcon />
            <div className="supported-devices-title">{trans('SUPPORTED_DEVICES_L')}</div>
          </div>
        </div>
        <SensorsList
          accessories={accessories}
          outdoorData={currentConditions}
          isLoading={isLoading}
          useruuid={userInfo?.useruuid}
          timezone={timezone}
          loginUserTimeformat={loginUserTimeformat}
          loginUserLocale={currentUserDataInfo?.locale}
          tempUnit={getTempUnit()}
        />
        {/* {showEnvSupportModal && (
          <EnvSupportModal
            showEnvSupportModal={showEnvSupportModal}
            closeEnvSupportModal={closeEnvSupportModal}
            envSupportDeviceData={envSupportDeviceData}
            allDeviceModels={allDeviceModels}
            activeSupportDevicesTab={activeSupportDevicesTab}
            handleSupportDeviceModal={handleSupportDeviceModal}
          />
        )} */}
      </div>
    </SSEEventContext.Provider>
  );
};

SmartHome.propTypes = {
  userInfo: PropTypes.object,
  timezone: PropTypes.string,
  loginUserTimeformat: PropTypes.shape({ is24hoursformat: PropTypes.bool }),
  openSubMenu: PropTypes.bool,
  hubRecord: PropTypes.shape({ useruuid: PropTypes.string }),
  loginUserMeasurementUnit: PropTypes.object,
};

export default SmartHome;
